import type * as React from "react";

export type StatCardProps = React.HTMLAttributes<HTMLDivElement> & {
  label: string;
  value: React.ReactNode;
  icon?: React.ReactNode;
  change?: { value: string; direction: "up" | "down" };
  description?: string;
  /** 0–100 bar heights for the sparkline. */
  trend?: number[];
};

/** Dashboard metric card. Value in tabular figures; optional sparkline. */
export function StatCard({
  label,
  value,
  icon,
  change,
  description,
  trend,
  className = "",
  ...props
}: StatCardProps) {
  return (
    <div
      className={["pr-card", "pr-card--hover", "pr-stat", className].filter(Boolean).join(" ")}
      {...props}
    >
      <div className="pr-stat__top">
        <p className="pr-stat__label">{label}</p>
        {icon && <span className="pr-stat__icon">{icon}</span>}
      </div>
      <div className="pr-stat__row">
        <div>
          <div className="pr-stat__value">{value}</div>
          {change && (
            <div className={`pr-stat__change pr-stat__change--${change.direction}`}>
              {change.direction === "up" ? "▲" : "▼"} {change.value}
            </div>
          )}
          {description && !change && (
            <div className="pr-help" style={{ marginTop: "0.4rem" }}>
              {description}
            </div>
          )}
        </div>
        {trend && trend.length > 0 && (
          <div className="pr-stat__spark" aria-hidden="true">
            {trend.map((h, i) => (
              // biome-ignore lint/suspicious/noArrayIndexKey: bar position is its identity
              <span key={i} style={{ height: `${Math.max(8, h)}%` }} />
            ))}
          </div>
        )}
      </div>
    </div>
  );
}
